import moment from "moment";
import { store } from "../store";
import {
  SET_ACCOUNT_LIST,
  SET_DEPOSIT_LIST,
  SET_LOAN_LIST,
  SET_SELECTED_ACCOUNT,
} from "../store/constants";
import { API_CONFIG } from "./constants/constant";
import http from "./http.service";

const getQuickAccounts = async (accType) => {
  try {
    const { app } = store.getState();
    const { profileDetails, accountList } = app;

    const reqParams = {
      requestId: "ACCOUNTDETAILS",
      //languagePrefference: null,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      acctType: accType,
    };

    if (accountList.length === 0) {
      const response = await http.post(API_CONFIG.getQuickAccounts, reqParams);
      if (response.status === 200) {
        response.data["data"]["accounts"]
          .sort((a, b) => b.primaryAccount - a.primaryAccount)
          .forEach((element) => {
            element.checked = false;
            element.acctShortName =
              element?.acctShortName || element.accountName;
            // element.effectiveAvailableBalance = Math.floor(100000 + Math.random() * 900000)
            // element.acctType = "SB"
          });
        store.dispatch({
          type: SET_ACCOUNT_LIST,
          payload: response.data["data"]["accounts"] || [],
        });
        if (response?.data["data"]["accounts"].length === 1) {
          store.dispatch({
            type: SET_SELECTED_ACCOUNT,
            payload: response?.data["data"]["accounts"][0],
          });
        } else {
          const selectedAccount =
            response?.data["data"]["accounts"].find(
              (ele) => ele.primaryAccount === true
            ) ||
            response.data["data"]["accounts"][0] ||
            [];
          store.dispatch({
            type: SET_SELECTED_ACCOUNT,
            payload: selectedAccount,
          });
        }
      }
      return {
        status: response.status,
        data: response.data["data"]["accounts"] || [],
      };
    } else {
      accountList
        .sort((a, b) => b.primaryAccount - a.primaryAccount)
        .forEach((element) => {
          element.checked = false;
        });
      return {
        status: 200,
        data: accountList || [],
      };
    }
  } catch (err) {
    return Promise.reject(err);
  }
};

const getAccountSummary = async (accType) => {
  try {
    const { app } = store.getState();
    const { profileDetails, accountList } = app;
    const reqParams = {
      requestId: "ACCOUNTDETAILS",
      //  languagePrefference: null,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      acctType: accType,
    };

    if (accountList.length === 0) {
      const response = await http.post(API_CONFIG.getAccountSummary, reqParams);
      if (response.status === 200) {
        response.data["custAccDetails"].forEach((element) => {
          element.checked = false;
          element.acctShortName =
              element?.acctShortName || element.accountName;
        });
        store.dispatch({
          type: SET_ACCOUNT_LIST,
          payload: response.data["custAccDetails"] || [],
        });
      }
      return {
        status: response.status,
        data: response.data["custAccDetails"] || [],
      };
    } else {
      accountList.forEach((element) => {
        element.checked = false;
      });
      return {
        status: 200,
        data: accountList || [],
      };
    }
  } catch (err) {
    return Promise.reject(err);
  }
};

const getDepositAccountSummary = async (accType) => {
  try {
    const { app } = store.getState();
    const { profileDetails, depositList } = app;
    const reqParams = {
      requestId: "ACCOUNTDETAILS",
      //  languagePrefference: null,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      acctType: accType,
    };

    if (depositList.length === 0) {
      const response = await http.post(API_CONFIG.getQuickAccounts, reqParams);
      if (response.status === 200) {
        response.data["data"]["accounts"].forEach((element) => {
          element.checked = false;
          element.acctShortName =
              element?.acctShortName || element.accountName;
        });
        store.dispatch({
          type: SET_DEPOSIT_LIST,
          payload: response.data["data"]["accounts"] || [],
        });
      }
      return {
        status: response.status,
        data: response.data["data"]["accounts"] || [],
      };
    } else {
      depositList.forEach((element) => {
        element.checked = false;
      });
      return {
        status: 200,
        data: depositList || [],
      };
    }
  } catch (err) {
    return Promise.reject(err);
  }
};

const getLoanAccountSummary = async (accType) => {
  try {
    const { app } = store.getState();
    const { profileDetails, loanList } = app;
    const reqParams = {
      requestId: "ACCOUNTDETAILS",
      //  languagePrefference: null,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      acctType: accType,
    };

    if (loanList.length === 0) {
      const response = await http.post(API_CONFIG.getQuickAccounts, reqParams);
      if (response.status === 200) {
        response.data["data"]["accounts"].forEach((element) => {
          element.checked = false;
        });
        store.dispatch({
          type: SET_LOAN_LIST,
          payload: response.data["data"]["accounts"] || [],
        });
      }
      return {
        status: response.status,
        data: response.data["data"]["accounts"] || [],
      };
    } else {
      loanList.forEach((element) => {
        element.checked = false;
      });
      return {
        status: 200,
        data: loanList || [],
      };
    }
  } catch (err) {
    return Promise.reject(err);
  }
};

const getBalanceEnquiry = async (data) => {
  try {
    const reqParams = {
      requestId: "GETBALANCES",
      accType: "BA",
      ...data,
    };
    const response = await http.post(API_CONFIG.getBalanceEnquiry, reqParams);
    return {
      status: response.status,
      data: response.data.balenceDetails || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getLastNTransactions = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      lastNTxn: "10",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.getLastNTransactions,
      reqParams
    );
    return {
      status: response.status,
      data: response.data["data"] || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getfullacctstmtwithpagination = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails, loanList } = app;

    const reqParams = {
      requestId: "FULLSTATEMENT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      sortIn: "A",
      hasMoreData: "N",
      ...data,
    };
    const response = await http.post(
      API_CONFIG.getfullacctstmtwithpagination,
      reqParams
    );
    return {
      status: response.status,
      data: response.data["data"],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getAccountSummaryByAccNo = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails, mode } = app;
    const reqParams = {
      requestId: "ACCOUNTDETAILS",
      module: "ACCOUNTS",
      mode: mode,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.getAccountSummaryByAccNo,
      reqParams
    );
    return {
      status: response.status,
      data: response.data["data"] || {},
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getTDAccDetails = async (data) => {
  try {
    const reqParams = {
      requestId: "TD_ACCT_INQ",
      ...data,
    };
    const response = await http.post(API_CONFIG.tdAccInq, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const raiseEStatementRequest = async (data) => {
  try {
    const reqParams = {
      requestId: "E_STATEMENT_REQUEST",
      ...data,
    };
    const response = await http.post(API_CONFIG.createOrUpdate, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getEStatementsDetails = async (data) => {
  try {
    const reqParams = {
      requestId: "ESTATEMENTCREATEORUPDATE",
      ...data,
      module: "ESTATEMENT",
    };
    const response = await http.post(
      API_CONFIG.getEStatementsDetails,
      reqParams
    );
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getLoanStatements = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails, loanList } = app;
    const reqParams = {
      ...data,
      requestId: "FULLSTATEMENT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.fullStatementPagination,
      reqParams
    );
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const editAccShortName = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "MPINRESETCONFIRM",
      module: "EDITSHORTNAME ",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.editAccShortName, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getProducts = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "TERMDEPOSITPRODUCT",
      module: "TERMDEPOSITE",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.getProducts, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getNomineeDetails = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "NOMINEELIST",
      module: "DEPOSIT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.getNomineeDetails, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const openFdOrRdVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "OPENTERMDEPOSITVERIFY",
      module: "OPENTERMDEPOSIT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.openFdOrRdVerify, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const openFdOrRdConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "OPENTERMDEPOSITCONFIRM",
      module: "OPENTERMDEPOSIT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.openFdOrRdConfirm, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getDashboardAccSummaryByDate = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "getDashboardAccSummaryByDate",
    };
    const response = await http.post(
      API_CONFIG.getDashboardAccSummaryByDate,
      reqParams
    );
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

function downloadPDFFile(blob, fileName) {
  const newBlob = new Blob([blob], { type: "application/pdf" });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  const data = window.URL.createObjectURL(newBlob);
  const link = document.createElement("a");
  link.href = data;
  link.download = `${fileName}.pdf`;
  link.click();
  setTimeout(() => {
    window.URL.revokeObjectURL(data);
  }, 100);
}

function downloadEXCELFile(blob, fileName) {
  const newBlob = new Blob([blob], {
    type: "application/xlsx",
  });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  const data = window.URL.createObjectURL(newBlob);
  const link = document.createElement("a");
  link.href = data;
  link.download = `${fileName}.xls`;
  link.click();
  setTimeout(() => {
    window.URL.revokeObjectURL(data);
  }, 100);
}

function downloadCSVFile(blob, fileName) {
  const newBlob = new Blob([blob], { type: "application/csv" });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  const data = window.URL.createObjectURL(newBlob);
  const link = document.createElement("a");
  link.href = data;
  link.download = `${fileName}.csv`;
  link.click();
  setTimeout(() => {
    window.URL.revokeObjectURL(data);
  }, 100);
}

function showXlsFile(blob, fileName) {
  const newBlob = new Blob([blob], { type: "application/xlsx" });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  const data = window.URL.createObjectURL(newBlob);
  const link = document.createElement("a");
  link.href = data;
  link.download = `${fileName}.xlsx`;
  link.click();
  setTimeout(() => {
    window.URL.revokeObjectURL(data);
  }, 100);
}

const statementDownload = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "DONWLOAD_STATMENT",
      module: "FUNDTRANSFER",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      encryptionNotReqd: true,
    };
    const response = await http.downloadPost(
      API_CONFIG.statementDownload,
      reqParams
    );
    const fileName = `xxxxxxxxxxx${reqParams.accountNo?.slice(
      reqParams.accountNo?.length - 3
    )}_${moment().valueOf()}`;
    if (reqParams.format === "PDF") {
      downloadPDFFile(response.data, fileName);
    } else if (reqParams.format === "EXCEL") {
      downloadEXCELFile(response.data, fileName);
    } else if (reqParams.format === "CSV") {
      downloadCSVFile(response.data, fileName);
    }
    return {
      status: response.status,
      data: { fileName: fileName },
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const statementExcelDownload = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "DONWLOAD_STATMENT",
      module: "FUNDTRANSFER",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      encryptionNotReqd: true,
    };
    const response = await http.downloadPost(
      API_CONFIG.statementExcelDownload,
      reqParams
    );
    const fileName = `xxxxxxxxxxx${reqParams.accountNo?.slice(
      reqParams.accountNo?.length - 3
    )}_${moment().valueOf()}`;

    downloadEXCELFile(response.data, fileName);
    return {
      status: response.status,
      data: { fileName: fileName },
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const emailStatement = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "FULLSTATEMENT",
      module: "FULLSTATEMENT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      encryptionNotReqd: true,
    };
    const response = await http.post(API_CONFIG.emailStatement, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const fetchDepositAdvise = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "DEBITCARD_STATUS",
      encryptionNotReqd: true,
    };
    const response = await http.downloadPost(
      API_CONFIG.DEPOSIT_ADVISE,
      reqParams
    );

    downloadPDFFile(response.data, reqParams.tdAccountNumber);

    return {
      status: response.status,
      data: [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const unfreezAccount = async (data) => {
  try {
    const reqParams = {
      requestId: "UN_FREEZ_ACCOUNT",
      frezAccountFlg: "N",
      ...data,
    };
    const response = await http.post(API_CONFIG.unfreezAccount, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const isEligibleToOpenTDAccount = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "ELIGIBLE_TO_OPEN_TD",
      module: "OPENTERMDEPOSIT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.isEligibleToOpenTDAccount,
      reqParams
    );
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getCityDetails = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "DEPOSITCITYCODES",
      module: "DEPOSIT",
      page: 0,
      size: 1000,
    };
    const response = await http.post(API_CONFIG.getCityDetails, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const editMinistatement = async (data) => {
  try {
    const reqParams = {
      requestId: "ACCOUNTDETAILS",
      module: "BENEFICIARY",
      ...data,
    };
    const response = await http.post(API_CONFIG.editMinistatement, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getLoanRequestValues = async (data) => {
  try {
    const reqParams = {
      requestId: "LOAN_REQEUST_VALUES",
      ...data,
    };
    const response = await http.post(
      API_CONFIG.getLoanRequestValues,
      reqParams
    );
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const loanRequestVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "LOANREQEUSTVERIFY",
      module: "LOANREQUEST",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.loanRequestVerify, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const loanRequestConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "LOANREQEUSTCONFIRM",
      module: "LOANREQUEST",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.loanRequestConfirm, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getBalances = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "MPINRESETCONFIRM",
      module: "LOGIN",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.getBalances, reqParams);
    return {
      status: response.status,
      data: response.data["data"],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};
const getAccountClasses = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "MPINRESETCONFIRM",
      module: "LOGIN",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.getAccountClasses, reqParams);
    return {
      status: response.status,
      data: response.data["data"],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const createCASAAccountVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "ADD_ACCOUNT_VERIFY",
      module: "CASAACCOUNT",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.createCASAAccountVerify,
      reqParams
    );
    return {
      status: response.status,
      data: response.data["data"],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const createCASAAccountConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "ADD_ACCOUNT_VERIFY",
      module: "CASAACCOUNT",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.createCASAAccountConfirm,
      reqParams
    );
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getLoanAccountStatement = async (data) => {
  try {
    const reqParams = {
      requestId: "ACCOUNTSTATEMENT",
      ...data,
    };
    const response = await http.post(
      API_CONFIG.getLoanAccountStatement,
      reqParams
    );
    return {
      status: response.status,
      data: response.data || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const siList = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "GETSIRECORDS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mode: "AA",
      ...data,
    };
    const response = await http.post(API_CONFIG.siList, reqParams);
    return {
      status: response.status,
      data: response.data || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const siView = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "VIEWSI",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      module: "SI",
    };
    const response = await http.post(API_CONFIG.siView, reqParams);
    return {
      status: response.status,
      data: response.data["data"],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const siCreateVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "CREATE_SI_VERIFY",
      module: "SI",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mode: "AA",
    };
    const response = await http.post(API_CONFIG.siCreateVerify, reqParams);
    return {
      status: response.status,
      data: response.data["data"],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const siCreateConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "CREATE_SI_CONFIRM",
      module: "SI",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mode: "AA",
    };
    const response = await http.post(API_CONFIG.siCreateConfirm, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const viewToken = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "CARDLESS_VIEW_TOKEN",
      module: "CARDLESSCASHOUT",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mode: "AA",
      page: 0,
      size: 1000,
    };
    const response = await http.post(API_CONFIG.viewToken, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const generateTokenVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "CARD_LESS_CASH_GEN_TOKEN_VERIFY",
      module: "CARDLESSCASH",
      txnType: "IAT",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mode: "AA",
    };
    const response = await http.post(API_CONFIG.generateTokenVerify, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const generateTokenConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "CARD_LESS_CASH_GEN_TOKEN_CONFIRM",
      module: "CARDLESSCASH",
      txnType: "IAT",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mode: "AA",
    };
    const response = await http.post(
      API_CONFIG.generateTokenConfirm,
      reqParams
    );
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const tokenAuthVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "CARDLESSCASHOUT_AUTH_VERIFY",
      module: "CARDLESSCASHOUT",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mode: "AA",
    };
    const response = await http.post(API_CONFIG.tokenAuthVerify, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const tokenAuthConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "CARDLESSCASHOUT_AUTH_CONFIRM",
      module: "CARDLESSCASHOUT",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mode: "AA",
    };
    const response = await http.post(API_CONFIG.tokenAuthConfirm, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getTokenRecords = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "GETRECORDS",
      module: "CARDLESSCASH",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mode: "AA",
    };
    const response = await http.post(API_CONFIG.getTokenRecords, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const cancelToken = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "CANCEL_TOKEN",
      module: "CARDLESSCASHOUT",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mode: "AA",
    };
    const response = await http.post(API_CONFIG.cancelToken, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const deleteCardlessCash = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "CARDLESSCASHDELETE",
      module: "CARDLESSCASH",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mode: "AA",
    };
    const response = await http.post(API_CONFIG.deleteCardlessCash, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getDepositAccountSummaryByAccNo = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails, mode } = app;
    const reqParams = {
      requestId: "ACCOUNTDETAILS",
      module: "ACCOUNTS",
      mode: mode,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.getDepositAccountSummaryByAccNo,
      reqParams
    );
    return {
      status: response.status,
      data: response.data["data"] || {},
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getLoanAccountSummaryByAccNo = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails, mode } = app;
    const reqParams = {
      requestId: "ACCOUNTDETAILS",
      module: "ACCOUNTS",
      mode: mode,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.getLoanAccountSummaryByAccNo,
      reqParams
    );
    return {
      status: response.status,
      data: response.data["data"] || {},
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const downloadTemplateForSalary = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "FILEUPLOADPROCESSLIST",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      encryptionNotReqd: true,
      ...data,
    };
    const response = await http.downloadPost(
      API_CONFIG.downloadTemplate,
      reqParams
    );
    const fileName = `sample_salary_upload_template${reqParams?.fileProcessId}`;
    showXlsFile(response.data, fileName);

    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const downloadTemplateForBulk = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "FILEUPLOADPROCESSLIST",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      encryptionNotReqd: true,
      ...data,
    };
    const response = await http.downloadPost(
      API_CONFIG.downloadTemplate,
      reqParams
    );
    const fileName = `sample_bulk_upload_template${reqParams?.fileProcessId}`;
    showXlsFile(response.data, fileName);

    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const downloadFileUploadStatusRecord = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "FILEUPLOADPROCESSLIST",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      encryptionNotReqd: true,
      ...data,
    };
    const response = await http.downloadPost(
      API_CONFIG.downloadFileUploadStatusRecord,
      reqParams
    );
    const fileName = `sample_salary_upload_template${reqParams?.fileProcessId}`;
    showXlsFile(response.data, fileName);

    return { status: response.status, data: { fileName: fileName } };
  } catch (err) {
    return Promise.reject(err);
  }
};

const downloadFileProcessList = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "FILEUPLOADPROCESSLIST",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.downloadFileProcessList,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getLoanDisbursement = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails, loanList } = app;
    const reqParams = {
      ...data,
      requestId: "ACCOUNTDETAILS",
      module: "ACCOUNTS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.getLoanDisbursement, reqParams);
    return {
      status: response.status,
      data: response.data["data"],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getLoanStatement = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails, loanList } = app;
    const reqParams = {
      module: "LOAN",
      requestId: "LOAN",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.getLoanStatement, reqParams);
    return {
      status: response.status,
      data: response.data["data"] || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const loanscheduleinq = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails, loanList } = app;
    const reqParams = {
      ...data,
      module: "LOAN",
      requestId: "LOAN",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.loanscheduleinq, reqParams);
    return {
      status: response.status,
      data: response.data["data"],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};
const repaymentConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails, loanList } = app;
    const reqParams = {
      ...data,
      module: "LOANREPAY",
      mode: "I",
      requestId: "LOANREPAY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.repaymentConfirm, reqParams);
    return {
      status: response.status,
      data: response.data["data"],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};
const repaymentVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails, loanList } = app;
    const reqParams = {
      ...data,
      module: "LOANREPAY",
      requestId: "LOANREPAY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.repaymentVerify, reqParams);
    return {
      status: response.status,
      data: response.data["data"],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const authSIVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "CREATE_SI_AUTHVERIFY",
      module: "SI",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.authSIVerify, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const authSIConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "SI",
      requestId: "CREATE_SI_AUTHCONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.authSIConfirm, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const siCancelVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "CANCEL_SI_VERIFY",
      module: "SI",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mode: "AA",
    };
    const response = await http.post(API_CONFIG.siCancelVerify, reqParams);
    return {
      status: response.status,
      data: response.data["data"],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const siCancelConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      requestId: "CANCEL_SI_CONFIRM",
      module: "SI",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mode: "AA",
    };
    const response = await http.post(API_CONFIG.siCancelConfirm, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getAllCharges = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "GET_CHARGES",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.getCharges, reqParams);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};
const AccountService = {
  getAccountSummary,
  getBalanceEnquiry,
  getQuickAccounts,
  getLastNTransactions,
  getDepositAccountSummary,
  getLoanAccountSummary,
  getfullacctstmtwithpagination,
  getAccountSummaryByAccNo,
  getTDAccDetails,
  raiseEStatementRequest,
  getEStatementsDetails,
  getLoanStatements,
  editAccShortName,
  getProducts,
  getDashboardAccSummaryByDate,
  statementDownload,
  fetchDepositAdvise,
  unfreezAccount,
  getNomineeDetails,
  openFdOrRdVerify,
  openFdOrRdConfirm,
  isEligibleToOpenTDAccount,
  getCityDetails,
  editMinistatement,
  getLoanRequestValues,
  loanRequestVerify,
  loanRequestConfirm,
  getBalances,
  getAccountClasses,
  createCASAAccountVerify,
  createCASAAccountConfirm,
  getLoanAccountStatement,
  siList,
  siView,
  siCreateVerify,
  siCreateConfirm,
  viewToken,
  generateTokenVerify,
  generateTokenConfirm,
  getTokenRecords,
  tokenAuthVerify,
  tokenAuthConfirm,
  cancelToken,
  getDepositAccountSummaryByAccNo,
  getLoanAccountSummaryByAccNo,
  downloadTemplateForSalary,
  downloadTemplateForBulk,
  downloadFileUploadStatusRecord,
  downloadFileProcessList,
  emailStatement,
  statementExcelDownload,
  getLoanDisbursement,
  getLoanStatement,
  loanscheduleinq,
  repaymentVerify,
  repaymentConfirm,
  authSIVerify,
  authSIConfirm,
  siCancelVerify,
  siCancelConfirm,
  deleteCardlessCash,
  getAllCharges,
};

export default AccountService;
